import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import "../Assets/Styles/layouts/header.scss";
import { FaSearch } from "react-icons/fa";
import { BsCart2 } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import products from "../Data/Products.json";
import { descriptionActions } from "../Store/DescriptionSlice";
import productsList from "../Data/Products.json";
import Login from "../Components/Login";
const axios = require("axios");
export default function HeaderLogic(props) {
  //  Ref's
  const modal = useRef(null);
  const locationInp = useRef(null);
  const navBarControl = useRef(null);
  // const mobileNumberInp = useRef(null);
  // const mobileNumberInpGet = mobileNumberInp.current;
  const loginModal = modal.current;
  const locationInpModal = locationInp.current;

  const items = [];
  const itemsCurrent = [];
  // States
  let [searchResults, updatesearchResults] = useState([]);
  const [locationModalStatus, updatelocationModalStatus] = useState(false);
  const [loginModalStatus, updateloginModalStatus] = useState(false);
  const [locations, updatelocations] = useState([]);
  const [errors, updateErrors] = useState(false);
  let [errorText, updateerrorText] = useState(" ");
  let [resultStatus, updateresultStatus] = useState(false);
  const uniqueItemsInCart = useSelector((state) => state.cart.totalQuantity);

  // Functions
  const handleLocation = () => updatelocationModalStatus(true);

  let token = localStorage.getItem("accessToken");
  const handleLoginModal = () => {
    token
      ? updateloginModalStatus(false) &&
        // eslint-disable-next-line no-restricted-globals
        location.reload()
      : updateloginModalStatus(true);
  };
  useEffect(() => {}, [token]);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateErrors(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [errors, locationModalStatus]);

  window.onclick = function (event) {
    if (event.target === locationInpModal) updatelocationModalStatus(false);
    if (event.target === loginModal) updateloginModalStatus(false);
  };
  const isNavCrossed = window.pageYOffset > navBarControl?.current?.offsetTop;

  // onClick fetch location
  const getLocationAuto = () => {
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(sendPosition, showError);
        function showError(error) {
          if (error.code === 1) {
            updateErrors(true);
            updatelocationModalStatus(false);
            return updateerrorText(`${error.message}, Please enable location! `);
          } else if (error.code === 2) {
            updateErrors(true);
            updatelocationModalStatus(false);
            return updateerrorText(`${error.message}`);
          }
        }
      }
    } catch (err) {
      updateErrors(true);
      return updateerrorText(`${err.message}`);
    }

    async function sendPosition(position) {
      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      try {
        const url = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&radius=100&key=${process.env.REACT_APP_API_KEY}`
        );
        const response = await url.json();
        itemsCurrent?.push(response?.results[1]?.formatted_address);
        updatelocations(itemsCurrent);
        updatelocationModalStatus(false);
        if (!itemsCurrent) return;
        localStorage?.setItem("uLocation", JSON.stringify(itemsCurrent));
      } catch (error) {
        updateErrors(true);
        updateerrorText(`${error.message}`);
        return updatelocationModalStatus(false);
      }
    }
  };

  // Get location by input
  const handleLocationInp = (e) => {
    let inputLocation = e.target.value;
    if (!inputLocation) return;

    const config = {
      method: "get",
      url: `https://blinkit.com/mapAPI/autosuggest_google?&query=${inputLocation}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios(config)
      .then(function (response) {
        if (!response) return;
        const stringifyRes = JSON.stringify(response?.data);
        if (!stringifyRes) return;
        const res = JSON.parse(stringifyRes);
        res?.predictions?.map((el, key) => {
          items?.push(el?.description);
          return items;
        });
        updatelocations(items);
      })
      .catch(function (error) {
        if (error) {
          updatelocationModalStatus(false);
          updateErrors(true);
          updateerrorText(error);
        }
      });
  };

  const setLocationAutoComplete = (clickedLocation) => {
    try {
      updatelocationModalStatus(false);
      return localStorage.setItem("uLocation", JSON.stringify(clickedLocation));
    } catch (error) {
      updateErrors(true);
      return updateerrorText(`${error.message}`);
    }
  };

  let userSetLocation = localStorage.getItem("uLocation");
  userSetLocation
    ? (userSetLocation = JSON.parse(localStorage.getItem("uLocation")))
    : (userSetLocation = "Select delivery location");

  ////////////----END OF LOCATION SERVICES ------/////////////

  const searchResultArr = [];
  const searchProductsHandler = (query) => {
    const inp = query.target.value.toLowerCase();
    if (!inp) updateresultStatus(true);
    else updateresultStatus(false);
    products?.map((el) =>
      el?.itemList?.filter((item) => (item?.title?.toLowerCase().includes(inp) ? searchResultArr?.push(item) : []))
    );

    updatesearchResults(searchResultArr);
  };
  const dispatch = useDispatch();
  const productDescrHandler = (item) => {
    updateresultStatus(true);
    let data = 0;
    item.map((el) => el.filter((product) => (data = product)));
    dispatch(descriptionActions?.showDescription(data));
  };

  useLayoutEffect(() => {
    const mainHeader = document.getElementById("#navbarI");
    let fixedTop = navBarControl.current.offsetTop;
    const fixedHeader = () => {
      if (window.pageYOffset > fixedTop) {
        mainHeader.classList.add("fix");
      } else {
        mainHeader.classList.remove("fix");
      }
    };
    window.addEventListener("scroll", fixedHeader);
  }, []);
  return (
    <React.Fragment>
      <header id="#navbarI" className="header m-b-vs" ref={navBarControl}>
        <div className="header-left-section">
          <div className="logo-container">
            <Link to="/">
              <svg width="100%" height="100%" viewBox="0 0 320 112.2">
                <g
                  id="SvgjsG1473"
                  featurekey="nameFeature-0"
                  transform="matrix(1.521385664394431,0,0,1.521385664394431,117.56577945479347,16.74492739896352)"
                  fill="#ff5722"
                >
                  <path d="M20.322 27.345 c1.213 0 2.196 0.98328 2.196 2.196 c0 5.7668 -4.692 10.459 -10.459 10.459 s-10.459 -4.692 -10.459 -10.459 l0 -7.0824 c0 -5.7668 4.692 -10.459 10.459 -10.459 s10.459 4.692 10.459 10.459 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 c0 -3.3452 -2.7215 -6.0668 -6.0668 -6.0668 s-6.0668 2.7215 -6.0668 6.0668 l0 7.0824 c0 3.3452 2.7215 6.0668 6.0668 6.0668 c2.571 0 4.7736 -1.6075 5.6556 -3.8706 l-5.6554 0 c-1.2128 0 -2.196 -0.98328 -2.196 -2.196 s0.98328 -2.196 2.196 -2.196 l8.2627 0 z M34.748 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 c-3.2543 0 -5.902 2.6476 -5.902 5.902 l0 8.098 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -16.196 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c1.1071 0 2.0201 0.81996 2.1716 1.885 c1.677 -1.1856 3.721 -1.885 5.9264 -1.885 z M47.162 19.412 c5.6764 0 10.294 4.6176 10.294 10.294 s-4.6176 10.294 -10.294 10.294 s-10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 z M47.162 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M81.5 31.9008 c0 0.00054688 0 0.0010938 0.00054688 0.0016406 l0 5.9014 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -4.9925 l-13.314 -13.314 l0 18.306 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -23.608 c0 -0.88832 0.535 -1.6891 1.3555 -2.0289 c0.82104 -0.33957 1.7654 -0.15207 2.3932 0.476 l7.3 7.3 l7.3 -7.3 c0.6278 -0.62808 1.5726 -0.8164 2.3932 -0.476 c0.82052 0.33984 1.3555 1.1406 1.3555 2.0289 l0 17.705 z M73.557 23.049 l3.5513 3.551 l0 -7.1024 z M101.848 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 l0 16.196 c0 1.2128 -0.98328 2.196 -2.196 2.196 c-1.1071 0 -2.0201 -0.81968 -2.1716 -1.885 c-1.677 1.1856 -3.721 1.885 -5.9264 1.885 c-5.6764 0 -10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 c2.2054 0 4.2492 0.69944 5.9264 1.885 c0.15152 -1.0654 1.0645 -1.885 2.1716 -1.885 z M93.75 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M116.28399999999999 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 c-3.2543 0 -5.902 2.6476 -5.902 5.902 l0 8.098 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -16.196 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c1.1071 0 2.0201 0.81996 2.1716 1.885 c1.677 -1.1856 3.721 -1.885 5.9264 -1.885 z M130.863 35.608 c1.2128 0 2.1961 0.98332 2.1961 2.1961 s-0.98328 2.196 -2.196 2.196 c-5.7668 0 -10.459 -4.692 -10.459 -10.459 l0 -15.345 c0 -1.2128 0.98328 -2.196 2.196 -2.196 s2.196 0.98328 2.196 2.196 l0 5.2217 l6.0666 0 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 l-6.0666 0 l0 5.7312 c0 3.3452 2.7215 6.0668 6.0668 6.0668 z" />
                </g>
              </svg>
            </Link>
            {/* <span className="separator"></span> */}
          </div>
          {props?.searchBar === true && (
            <div className="search-bar">
              <input type="search" placeholder="Search for items" onChange={searchProductsHandler} />
              <span className="cta-search">
                <span>
                  <FaSearch />
                </span>
              </span>
              <div className="search-results">
                {searchResults
                  ?.filter((item, idx) => idx <= 6)
                  .map((result, key) => (
                    <div className={resultStatus === true || !result ? "results disable" : "results"} key={key}>
                      <Link
                        key={result.id}
                        to="/description"
                        onClick={() =>
                          productDescrHandler(
                            productsList?.map((el, key) => el?.itemList?.filter((item) => item.id === result.id))
                          )
                        }
                      >
                        {result.title}
                      </Link>
                    </div>
                    //  (item.title === result ? item : null
                  ))}
              </div>
            </div>
          )}
        </div>
        {/* <p>{searchResults}</p> */}
        <div className="header-right-section">
          {props?.getLocation === true && (
            <React.Fragment>
              <div className="location-container">
                <MdLocationOn title={userSetLocation} className="caret-down" />
                <div className="location-bar-container" onClick={handleLocation}>
                  {/* <span>Delivery at - </span> */}
                  <p title={userSetLocation}>
                    {userSetLocation.length >= 25 ? userSetLocation.slice(0, 25) + " ..." : userSetLocation}
                  </p>
                </div>
              </div>{" "}
              <div ref={locationInp} className={locationModalStatus === true ? "getLocation " : "getLocation disable"}>
                <div className="location-container">
                  <div className="location-header">
                    <p>Let's get your location </p>
                  </div>
                  <div className="location-body">
                    <div className="locationInputContainer">
                      <div className="searchLoc">
                        <input
                          type="text"
                          name="location-list"
                          list="browseLocations"
                          placeholder="Type your location"
                          onChange={handleLocationInp}
                          autoComplete="off"
                        />
                        <div className="autocomplete-main">
                          {locations?.map((el, key) => (
                            <div
                              onClick={() => setLocationAutoComplete(el)}
                              key={key}
                              className={!el ? "autocomplete-container disable" : "autocomplete-container"}
                            >
                              <p>{el}</p>
                            </div>
                          ))}
                        </div>
                      </div>

                      <p className="or"> OR </p>

                      <button className="detection-btn" onClick={getLocationAuto}>
                        Detect
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className="login-link-btn-container" onClick={() => handleLoginModal()}>
            {props.login === true && <p className="login">Login</p>}
          </div>
          <div>
            {props.login === false && (
              <Link to="/account" className="login" style={{ textDecoration: "none", color: "currentcolor", fontSize: "1.8rem" }}>
                Account
              </Link>
            )}
          </div>

          {props.cart === true && (
            <Link to="/cart" className="cart-link-btn-container">
              <BsCart2 value={{ className: "global-class-name cart-ico" }} />
              <p className="cart-items"> {uniqueItemsInCart >= 1 ? ` ${uniqueItemsInCart} Items` : "Cart"} </p>
            </Link>
          )}
          <div ref={modal} className={loginModalStatus === true ? "loginFixed" : "loginFixed disable"}>
            <div className="login-container">
              <Login />
            </div>
          </div>
        </div>
        <div className={errors === true ? "alert failure" : "alert failure disable"}>
          <p>{errorText}</p>
        </div>
      </header>
    </React.Fragment>
  );
}
